<script>
  import { productDataStore } from '../../stores/ProductData.js';

  import determineProductColourImageUrl from '../../utils/determineProductColourImageUrl.js';

  export let selectedProductsArray = [];

  // Holds each product's resolved preview URL (e.g. { top: 'http://...', bottom: 'http://...' })
  let productPreviews = {};

  // Whenever selectedProductsArray changes, fetch any missing preview URLs
  $: (async () => {
    if (!selectedProductsArray) return;

    for (const productType of selectedProductsArray) {
      const storeItem = $productDataStore[productType];
      // If there's no actual product data for that type, skip
      if (!storeItem) continue;

      productPreviews[productType] = await determineProductColourImageUrl({
        productSlug: storeItem.rootSlug,
        colourPathName: storeItem.selectedColour.pathName,
        colourObject: storeItem.selectedColour,
        side: 'front',
        showModel: false,
        imageSize: 128,
        imageType: 'jpg',
        gender: storeItem.gender,
        isModelBasedImages: storeItem.isModelBasedImages,
        sublimationTemplateId: storeItem.selectedSublimationTemplate?.SublimationTemplate?.id,
      });
    }
  })();

  function handleClickProduct(productType) {
    $productDataStore.showing = productType;
  }
</script>

<!-- Render each selected product and its preview -->
<div class="selected-preview-container">
  {#if selectedProductsArray && selectedProductsArray.length > 1}
    {#each selectedProductsArray as selectedProduct}
      <div class="selected-product" on:click={() => handleClickProduct(selectedProduct)}>
        <img src={productPreviews[selectedProduct] || 'img/design/not-available-for-gender.jpg'} alt="preview" />
        <div class="label">{selectedProduct}</div>
      </div>
    {/each}
  {/if}
</div>

<style>
  .selected-preview-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .selected-product {
    display: flex;
    align-items: center;
    margin: 0.5rem;
    padding: 0.5rem;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 1px 1px 0.5rem rgba(0, 0, 0, 0.15);
    cursor: pointer;
  }

  .selected-product:hover {
    border: 1px solid rgba(0, 0, 0, 0.15);
  }

  .selected-product img {
    max-height: 40px;
    margin-right: 0.5rem;
  }

  .label {
    text-transform: capitalize;
    font-size: 1.2rem;
  }
</style>
